import React from "react";
import { NavLink } from "react-router-dom";
import { CLASSIC_SITE_BASE } from "../classicSite.constants";

const LINKS = [
  { to: `${CLASSIC_SITE_BASE}/member`, label: "Dashboard", end: true },
  { to: `${CLASSIC_SITE_BASE}/member/account`, label: "Account" },
  { to: `${CLASSIC_SITE_BASE}/member/listings`, label: "Listings" },
  { to: `${CLASSIC_SITE_BASE}/member/billing`, label: "Billing" },
  { to: `${CLASSIC_SITE_BASE}/member/auth`, label: "Session" },
];

export default function MemberNav() {
  return (
    <nav className="cs-member-nav" aria-label="Member portal">
      {LINKS.map(({ to, label, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            `cs-member-nav__link${isActive ? " cs-member-nav__link--active" : ""}`
          }
        >
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
